import { object, boolean } from 'yup';
import { isCustomerSpecificTask } from '@ourbranch/onboarding-tasks';

import { getPreSaleChecklistConditions } from '../../helper';

// Inline version of createTaskUniqueKey from @ourbranch/onboarding-tasks/client
// (that package has backend-only dependencies that can't be imported in the browser)
const createTaskUniqueKey = (task) => {
  const { taskName, data } = task;
  if (isCustomerSpecificTask(taskName) && data?.customer) {
    return `${taskName}:${data.customer}`;
  }
  return taskName;
};

export default (policyType, quote, values, offer, tasks) => {
  // Always required
  let schema = object().shape({
    authorizePayments: boolean().required().oneOf([true]),
    branchCommunicationConsent: boolean().required().oneOf([true]),
    confirmDiscounts: boolean().required().oneOf([true]),
    confirmCoverages: boolean().required().oneOf([true])
  });

  const tasksWithDocuments = tasks.filter((task) => task.data?.hasDocument).map((task) => createTaskUniqueKey(task));

  const preSaleChecklistConditions = getPreSaleChecklistConditions(
    quote,
    values,
    policyType,
    offer,
    tasksWithDocuments
  );

  // Conditionally required
  Object.entries(preSaleChecklistConditions).forEach(([key, value]) => {
    if (
      ![
        'payingInFull',
        'payingMonthly',
        // nodes for trailing docs validation node, not needed for individual validation
        'hasSPP',
        'hasInventoryDiscount',
        'hasConnectedHome',
        'hasGoodStudent',
        'hasTakenDrivingCourse',
        'hasKiaOrHyundai'
      ].includes(key) &&
      value
    ) {
      schema = schema.concat(
        object().shape({
          [key]: boolean().required().oneOf([true])
        })
      );
    }
  });

  return schema;
};
